'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var moduleName = 'appControllers';

angular.module(moduleName, [])
    .controller('menuController', ['$scope', '$rootScope', require('./controllers/menu')])
    .controller('headerController', ['$scope', '$rootScope', '$mdSidenav', '$mdMedia', 'AuthenticationService', '$location', '$translate', require('./theme/header/controller')])
    .controller('purchaseBlockController', ['$scope', '$timeout', '$mdDialog', 'Restangular', 'FlashService', require('./theme/purchases/block/controller')])
    .controller('purchaseLicenceBlockController', ['$scope', '$timeout', '$mdDialog', 'Restangular', 'FlashService', require('./theme/purchase_licence/block/controller')])
;

exports.default = moduleName;
module.exports = exports['default'];



/** WEBPACK FOOTER **
 ** ./js/controllers.js
 **/